import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface RoadsterDefaultIconProps {
  color?: Color;
}

const RoadsterDefaultIcon: React.FC<RoadsterDefaultIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_45101)">
      <path
        d="M68.58 29.63L71.99 28.26C72.5724 27.3316 72.9159 26.2735 72.99 25.18C72.9812 24.8785 72.8914 24.5848 72.73 24.33L71.73 23.9V21.08C71.5658 20.377 71.2212 19.729 70.73 19.2V17.92C67.1952 17.3379 63.6288 16.9673 60.0499 16.81H49.38C49.29 16.81 49.21 16.64 49.12 16.47C49.03 16.3 49.03 16.04 48.95 15.79C48.8845 15.4682 48.6969 15.1842 48.4265 14.9978C48.1562 14.8113 47.8241 14.7369 47.5 14.79C46.81 14.79 46.81 15.39 46.73 16.24C46.7136 16.6417 46.7404 17.044 46.8099 17.44L25.03 18.44"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M11.4299 29.97L3.42993 29.54L3.85999 23.99C3.9375 23.4737 4.13176 22.982 4.4281 22.5522C4.72444 22.1224 5.11499 21.766 5.56995 21.51C6.67995 20.74 8.81 20.23 11.12 19.63C14.198 18.6736 17.3818 18.0993 20.6 17.92C20.6 17.92 27.26 13.65 33.75 12.37"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M54.91 29.79L25.87 29.96" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M23.9 26.64C23.9504 27.7904 23.6584 28.9298 23.061 29.9142C22.4636 30.8986 21.5876 31.6837 20.5439 32.1701C19.5002 32.6565 18.3357 32.8223 17.1977 32.6467C16.0597 32.471 14.9993 31.9617 14.1508 31.1833C13.3024 30.4048 12.7039 29.3922 12.4311 28.2734C12.1583 27.1547 12.2237 25.9803 12.6186 24.8986C13.0136 23.817 13.7204 22.8768 14.6499 22.1971C15.5793 21.5173 16.6895 21.1286 17.8399 21.08C19.2366 20.9989 20.6112 21.4571 21.6799 22.36"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M67.47 26.64C67.5203 27.7899 67.2285 28.929 66.6315 29.9131C66.0345 30.8972 65.1591 31.6822 64.116 32.1688C63.0728 32.6553 61.9088 32.8217 60.7711 32.6468C59.6334 32.4719 58.5733 31.9636 57.7245 31.1861C56.8757 30.4086 56.2765 29.3969 56.0027 28.2789C55.7289 27.1609 55.7926 25.9869 56.186 24.9051C56.5795 23.8234 57.2848 22.8827 58.2129 22.2018C59.141 21.5209 60.2501 21.1305 61.4 21.08C62.797 20.9968 64.1723 21.4553 65.24 22.36"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M5.27998 22.62C5.01998 22.96 5.27998 23.9 5.27998 23.9H8.69991C9.29991 23.9 9.88988 22.02 9.54988 21.77C9.20988 21.52 5.53998 22.28 5.27998 22.62Z"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M71.74 21.17L70.71 21.08L69.86 19.88L70.8 19.2"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_45101">
        <rect width="70.39" height="21.08" fill="white" transform="translate(3 12)" />
      </clipPath>
    </defs>
  </svg>
);

export default RoadsterDefaultIcon;
